import API from './'

const auth = {

	login(credentials = {})
	{
		let url = API.getUrl('login', true)

		return API.client().post(url, credentials)
	},

	user(params={})
	{
		let url = API.getUrl('user')

		return API.client().get(url, { params })
	},

	deploy(token, extraParams={})
	{
		const url = API.getUrl('user/deploy'),
			params = { token, ...extraParams }

		return API.client().post(url, params)
	}

}

export default auth